var path = '/modules/core/components/al-iframe-preview/component.tpl.html';
var html = "<div class=\"al-iframe-preview mt-{{vm.marginTop}}\" ng-class=\"'viewport-' + vm.internalViewPort\">\n    <img class=\"viewport-frame\" ng-if=\"vm.internalViewPort === 'mobile'\"\n         src=\"/images/iphone-maske.svg\"\n         alt=\"\">\n    <img class=\"viewport-frame\" ng-if=\"vm.internalViewPort === 'tablet'\"\n         src=\"/images/tablet-maske.svg\"\n         alt=\"\">\n\n    <iframe></iframe>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/core/components/al-iframe-preview/component.tpl.html
// module id = 2086
// module chunks = 1